import React, { useContext } from 'react'
import { camelCase } from 'lodash'
import { autoScroll } from '@/utils/animations'
import { CartContext } from '@/store/cart'
import QuantityInput from '@/components/CartItem/QuantityInput'
import Price from './Price'
import { isPillowBundle } from '@/utils/product'
import ItemThumbnail from '../ItemThumbnail'
import NameLink from '@/components/CartItem/NameLink'

import styles from '@/components/CartItem/styles.module.scss'

const SavedForLater = ({ item }) => {
    const { cart, addItemToCart, removeSavedForLater, addSavedForLater, updateItemInCart } = useContext(CartContext)
    const bundleSuffix = '2-pack'

    const moveToCart = async () => {
        const itemInCart = cart.items.find(cartItem => cartItem.sku === item.sku)

        if (itemInCart) {
            await updateItemInCart(itemInCart, (itemInCart.quantity + item.quantity), 'savedForLater')
        } else {
            await addItemToCart([item], 'savedForLater')
        }
        await removeSavedForLater([item.sku])

        autoScroll('cartSection')
    }

    const onIncrease = async () => {
        await addSavedForLater({...item, quantity: 1})
    }

    const onDecrease = async () => {
        await addSavedForLater({...item, quantity: -1})
    }

    const removeItem = async () => {
        await removeSavedForLater([item.sku])
        autoScroll('cartSection') || autoScroll('cartEmpty')
    }

    const productAttributes = item.productAttributes || []
    const name = () => {
        let nameAdjusted = item.genericName

        if (isPillowBundle(item.sku) && !item.genericName.includes(bundleSuffix)) {
            nameAdjusted = `${nameAdjusted}, ${bundleSuffix}`
        }

        return nameAdjusted
    }

    return (

        <div className={styles.mainContainer}>
            <ItemThumbnail cartItem={item} desktop />
            <div className={styles.contentContainer}>
                <div className={styles.cartItemTop}>
                    <NameLink item={{...item, genericName: name()}} />
                    <Price item={item} dataSelector='saveForLater' />
                </div>
                <div className={styles.cartItemMiddle}>
                    <ItemThumbnail cartItem={item} />
                    <ul className={styles.attributesList}>
                        {productAttributes.map(({ name, value }) => (
                            <li key={`attr-${name}`} data-selector={`saveForLater_attribute_${camelCase(name)}`}>
                                <span className={styles.attributeLabel}>{name}:</span>{' '}
                                <b className={styles.attributeValue}>{value}</b>
                            </li>
                        ))}
                    </ul>
                    <div>
                        <QuantityInput
                            itemQuantity={item.quantity}
                            onIncrease={onIncrease}
                            onDecrease={onDecrease}
                            onRemove={removeItem}
                            dataSelector='saveForLater'
                        />
                        <div className={styles.cartActions}>
                            <button className={styles.saveForLaterLink} onClick={moveToCart} data-selector='saveForLater_moveToCart'>
                                Move to cart
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}




export default SavedForLater
